var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"MeasuresCount"},[_c('Measure'),_c('DistanceMeasurement'),_c('labels'),_c('DeleteLabel')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }